export const ErrorMapping = {
  FIELD_REQUIRED: "Attenzione! il campo è obbligatorio",
  OLD_PASSWORD_MINLENGTH: "Attenzione! La password inserita deve essere composta da almeno 4 caratteri.",
  PASSWORD_PATTERN: "Attenzione! Inserire almeno 4 diverse tipologie di caratteri (lettere maiuscole, lettere minuscole, numeri e caratteri speciali: #?!\"@.&*$£€-) ed un numero minimo di 14 caratteri.",
  PASSWORD_MATCH: "Attenzione! La password non coincide con quella inserita.",
  EMAIL: "Attenzione! La mail inserita non è valida.",
  PASSWORD_LAST_FIVE: "La password non può coincidere con una delle ultime 5 password impostate.",
  PASSWORD_EXPIRED: "La password è scaduta.",
  PASSWORD_INVALID: "La password inserita non è corretta.",
  PASSWORD_GENERAL: "Si è verificato un errore in fase di aggiunta di modifica della password.",
  PASSWORD_LOWER_CASE: "Inserire almeno una lettera minuscola.",
  PASSWORD_UPPER_CASE: "Inserire almeno una lettera maiuscola.",
  PASSWORD_NUMBER_CASE: "Inserire almeno un numero.",
  PASSWORD_SPECIAL_CASE: "Inserire almeno un carattere speciale (@$!%*?&).",
  PASSWORD_LENGTH: "Inserire almeno 14 caratteri.",
  PASSWORD_EQUAL_CHAR: "Non inserire due caratteri uguali consecutivi."

}
